module.exports = __webpack_public_path__ + "static/media/soict.464b2914.svg";